export const getBrowserLanguage = () =>
  window.Localize ? window.Localize.getLanguage() : window.browserLocale().replace(/-.+/, '');

export interface IReportingPayment {
  pos?: {
    order?: {
      humanReadableId?: string;
    };
  };
  pspId?: {
    id?: string;
  };
  salesChannel?: string;
}

// For navigating to a specific order page in the POS
export function loadOrder(payment: IReportingPayment) {
  const orderId = payment.pos?.order?.humanReadableId;
  const salesChannel = payment.salesChannel ?? '';

  if (salesChannel === 'IN_STORE' && orderId) {
    window.navigateToContent('view', 'transaction.views.transaction', orderId);
  }
}

// Navigates the parent window to the invoice payment-allocations resolver.
// Pay-balance payments have no R-Series sale id, so fall back to the PSP charge
// id, which the resolver maps to the invoicing payment server-side.
export function loadInvoiceAllocations(payment: IReportingPayment) {
  const saleId = payment.pos?.order?.humanReadableId;
  const chargeId = payment.pspId?.id;

  let query: string | null = null;
  if (saleId) {
    query = `saleId=${encodeURIComponent(saleId)}`;
  } else if (chargeId) {
    query = `chargeId=${encodeURIComponent(chargeId)}`;
  }

  if (query) {
    window.merchantos.utils.openUrl(`/admin/customers/payment-allocations-resolve?${query}`);
  }
}

export const getReferringTab = () => {
  const tabs = window.merchantos.tabs;

  return tabs.currentTab === 'financial_services' ? tabs.previousTab : tabs.currentTab;
};
